<template>
	<p
		class="font-sans-caption"
		:class="{
			'text-sm leading-snug': size === 'sm',
			'text-base leading-5 tracking-xl': size === 'base',
		}"
	>
		<slot></slot>
	</p>
</template>

<script lang="ts" setup>
withDefaults(
	defineProps<{
		size?: "sm" | "base";
	}>(),
	{
		size: "base",
	},
);
</script>
